<mat-toolbar class="footer">
    <span>
        2026 © Kiron Sistemas - v2.26
    </span>
</mat-toolbar>
